// import React from "react";
// import "./style.css";
// import { useSelector } from "react-redux";

// const SeatsProgressBar = ({ totalSeats = 0, activeSeats = 0 }) => {
//   const pendingSeats = totalSeats - activeSeats;
//   const activePercent = (activeSeats / totalSeats) * 100;
//   const pendingPercent = (pendingSeats / totalSeats) * 100;

//   return (
//     <div className="seats_progress_container">
//       <div className="seats_progress_bar">
//         <div
//           className="seats_progress_pending"
//           style={{ width: `${pendingPercent}%` }}
//         />
//         <div
//           className="seats_progress_active"
//           style={{ width: `${activePercent}%` }}
//         />
//       </div>
//     </div>
//   );
// };

// export default SeatsProgressBar;

// import React, { useMemo } from "react";
// import "./style.css";

// const SeatsProgressBar = ({ totalSeats = 0, activeSeats = 0 }) => {
//   const { pendingSeats, activePercent, pendingPercent } = useMemo(() => {
//     const pending = totalSeats - activeSeats;
//     const activeP = totalSeats > 0 ? (activeSeats / totalSeats) * 100 : 0;
//     const pendingP = totalSeats > 0 ? (pending / totalSeats) * 100 : 0;

//     return {
//       pendingSeats: pending,
//       activePercent: activeP,
//       pendingPercent: pendingP,
//     };
//   }, [totalSeats, activeSeats]);

//   return (
//     <div className="seats_progress_container">
//       <div className="seats_progress_bar">
//         <div
//           className="seats_progress_pending"
//           style={{ width: `${pendingPercent}%` }}
//         />
//         <div
//           className="seats_progress_active"
//           style={{ width: `${activePercent}%` }}
//         />
//       </div>
//     </div>
//   );
// };

// export default SeatsProgressBar;

import React, { useMemo } from "react";
import "./style.css";

const SeatsProgressBar = ({ totalSeats = 0, activeSeats = 0 }) => {
  const { pendingSeats, activePercent, pendingPercent } = useMemo(() => {
    const pending = totalSeats - activeSeats;
    const activeP = totalSeats > 0 ? (activeSeats / totalSeats) * 100 : 0;
    const pendingP = totalSeats > 0 ? (pending / totalSeats) * 100 : 0;

    return {
      pendingSeats: pending,
      activePercent: activeP,
      pendingPercent: pendingP,
    };
  }, [totalSeats, activeSeats]);

  return (
    <div className="seats_progress_container">
      <div className="seats_progress_bar">
        <div
          className="seats_progress_active"
          style={{ width: `${activePercent}%` }}
        />
        <div
          className="seats_progress_pending"
          style={{ width: `${pendingPercent}%` }}
        />
      </div>
      <div className="seats_info">
        {activeSeats} / {totalSeats} Seat
        {activeSeats !== 1 ? "s" : ""} used
      </div>
    </div>
  );
};

export default SeatsProgressBar;
